<template>
  <div style="border: solid 1px #999; padding: 10px; margin-top: 10px">
    <div style="display: flex; align-items: center">
      <el-form
          ref="form"
          :model="formData"
          size="mini"
          label-width="90px"
          style="width: 100%"
      >
        <el-form-item label="当前角色:" prop="role">
          <el-radio-group v-model="formData.role" style="margin-left: 30px" @change="handleChangeRole"
                          :disabled="formData.addType=='view'">
            <el-radio
                v-for="item in roleArr"
                :key="item.value"
                :label="item.label"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="内容形式:" prop="contentPattern">
          <el-radio-group
              v-model="formData.contentPattern"
              style="margin-left: 30px"
              :disabled="formData.addType=='view'"
          >
            <el-radio
                v-for="item in contentTypeArr"
                :key="item.value"
                :label="item.value"
            >{{ item.label }}
            </el-radio
            >
          </el-radio-group>
        </el-form-item>

        <!--文本转语音-->
        <template v-if="formData.contentPattern === 'audioText'">
          <AudioText :formData="formData" @onOpenPickTextMaterialModal="onOpenPickTextMaterialModal"></AudioText>
        </template>
        <!--视频-->
        <template v-if="formData.contentPattern === 'video'">
          <el-form-item label="上传视频:">
            <template v-if="videoUrl">
              <y-j-video
                  style="width: 400px; height: 200px"
                  :src="videoUrl"
              />
              <div style="text-align: right; width: 400px">
                <el-button
                    class="btn"
                    size="mini"
                    type="primary"
                    @click="handleUploadNewVideo"
                    :disabled="formData.addType=='view'"
                >重新上传
                </el-button>
              </div>
            </template>
            <template v-else>
              <el-upload
                  v-loading="loading"
                  element-loading-text="上传中，请勿操作"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  drag
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :before-upload="beforeUploadVideo"
                  :on-change="handleVideoChange"
              >
                <i class="el-icon-upload"></i>
                <div>
                  <el-button
                      class="btn"
                      size="mini"
                      type="primary"
                      slot="trigger"
                      :disabled="formData.addType=='view'"
                  >上传视频
                  </el-button>
                  <el-button
                      class="btn"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      @click="pickMaterial"
                      :disabled="formData.addType=='view'"
                  >素材库
                  </el-button>
                </div>
              </el-upload>
            </template>
          </el-form-item>
        </template>
        <!--音频-->
        <template v-if="formData.contentPattern === 'audio'">
          <el-form-item label="上传音频:">
            <template v-if="audioUrl">
              <y-j-video
                  style="width: 400px; height: 200px"
                  :src="audioUrl"
              />
              <div style="text-align: right; width: 400px">
                <el-button
                    class="btn"
                    size="mini"
                    type="primary"
                    @click="handleUploadNewAudio"
                    :disabled="formData.addType=='view'"
                >重新上传
                </el-button>
              </div>
            </template>
            <template v-else>
              <el-upload
                  v-loading="loading"
                  element-loading-text="上传中，请勿操作"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  drag
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :before-upload="beforeUploadAudio"
                  :on-change="handleAudioChange"
              >
                <i class="el-icon-upload"></i>
                <div>
                  <el-button
                      class="btn"
                      size="mini"
                      type="primary"
                      slot="trigger"
                      :disabled="formData.addType=='view'"
                  >上传音频
                  </el-button>
                  <el-button
                      class="btn"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      @click="pickMaterial"
                      :disabled="formData.addType=='view'"
                  >素材库
                  </el-button>
                </div>
              </el-upload>
            </template>
          </el-form-item>
        </template>
        <!--图片-->
        <template v-if="formData.contentPattern === 'image'">
          <el-form-item label="图片：">
            <div class="itemBox">
              <el-upload
                  v-loading="loading"
                  element-loading-text="上传中，请勿操作"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="handleImgChange"
                  :before-upload="beforeImageUpload"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div>
                  <el-button
                      class="btn"
                      v-if="imageUrl"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      :disabled="formData.addType=='view'"
                  >重新上传
                  </el-button>
                  <el-button
                      class="btn"
                      v-else
                      size="mini"
                      type="primary"
                      slot="trigger"
                      :disabled="formData.addType=='view'"
                  >上传图片
                  </el-button>
                  <el-button
                      class="btn"
                      size="mini"
                      plain
                      type="primary"
                      slot="trigger"
                      @click="pickMaterial"
                      :disabled="formData.addType=='view'"
                  >素材库
                  </el-button>
                </div>
              </el-upload>
            </div>
          </el-form-item>
        </template>

        <!--<el-button
                          size="mini"
                          type="primary"
                          @click="handlePrint"
                          >打印
                        </el-button>-->
      </el-form>
    </div>
    <MaterialPickModal
        :materialType="materialType"
        @onConfirmPickMaterial="onConfirmPickMaterial"
    ></MaterialPickModal>
  </div>
</template>

<script>
import {mapMutations, mapActions, mapState} from "vuex";
import {CONTENT_PATTERN} from "@/utils/constants";
import AudioText from "./AudioText.vue";
import MaterialPickModal from "../../MaterialCenter/components/MaterialPickModal.vue";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "LessonContentCommon",
  components: {
    YJVideo,
    AudioText,
    MaterialPickModal,
  },
  data() {
    const 内容类型选项 = Object.keys(CONTENT_PATTERN).map((key) => {
      return {
        value: key,
        label: CONTENT_PATTERN[key],
      };
    });

    return {
      materialType: "audioText",
      formData: {},
      //当前角色
      roleArr: [
        {
          label: "老师",
          value: 1,
        },
        {
          label: "学生",
          value: 2,
        },
      ],
      contentTypeArr: [...内容类型选项],
      roleArrStudent: [
        {
          label: "学生",
          value: 2,
        },
      ],
      // 音频
      audioUrl: "",
      // 视频
      videoUrl: "",
      //图片
      imageUrl: "",
      loading: false,
    };
  },
  computed: {
    ...mapState("tenant", ["ossUploadObj"]),
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    initFormData(data) {
      this.formData = JSON.parse(JSON.stringify(data));

      this.audioUrl = "";
      this.videoUrl = "";
      this.imageUrl = "";
      let material = this.formData.lessonContentTemplate.material;
      if (material != null) {
        if (material.type === "image") {
          this.imageUrl = material.materialUrl;
        } else if (material.type === "audio") {
          this.audioUrl = material.materialUrl;
        } else if (material.type === "video") {
          this.videoUrl = material.materialUrl;
        }
      }
    },
    getFormData() {
      this.formData.imageUrl = this.imageUrl;
      this.formData.audioUrl = this.audioUrl;
      this.formData.videoUrl = this.videoUrl;

      if (!this.formData.lessonContentTemplate.materials[0])
        this.formData.lessonContentTemplate.materials[0] = {};

      this.formData.lessonContentTemplate.materials[0].materialUrl =
          this.formData.lessonContentTemplate.material.materialUrl;
      this.formData.lessonContentTemplate.materials[0].duration =
          this.formData.lessonContentTemplate.material.duration;
      this.formData.lessonContentTemplate.materials[0].filename =
          this.formData.lessonContentTemplate.material.filename;

      this.formData.lessonContentTemplate.material.type = this.formData.contentPattern;
      this.formData.lessonContentTemplate.materials[0].type = this.formData.contentPattern;

      if (
          this.formData.lessonContentTemplate.material.id == undefined ||
          this.formData.lessonContentTemplate.material.id == ""
      ) {
        this.formData.lessonContentTemplate.material.id = (
            (Math.random() + new Date().getTime()) *
            10000
        ).toString(32);
      }

      return JSON.parse(JSON.stringify(this.formData));
    },
    //更换type
    handleChangeRole() {
      if (this.formData.role === "学生") {
        this.defaultVoiceMethod("zhigui");
      } else {
        this.defaultVoiceMethod("zhiyuan");
      }
    },

    // 声音属性默方法
    defaultVoiceMethod(voice) {
      if (this.isSituational) {
        this.formData.lessonContentTemplate.materials[3].voice = voice;
        this.formData.lessonContentTemplate.materials[3].speechRate = 1.0;
      }
      if (
          this.formData.type === "select" ||
          this.formData.type === "multipleSelect" ||
          this.formData.type === "judge" ||
          this.formData.type === "sort" ||
          this.formData.type === "text" ||
          this.formData.type === "imageSelect"
      ) {
        this.formData.lessonContentTemplate.materials[0].voice = voice;
        this.formData.lessonContentTemplate.materials[0].speechRate = 1.0;
      }
      if (this.formData.type === "audioText") {
        this.formData.lessonContentTemplate.material.voice = voice;
        this.formData.lessonContentTemplate.material.speechRate = 1.0;
      }
    },
    //题干转音频
    handleChangeTitleAudio(val) {
      this.formData.lessonContentTemplate.material.audioText = val;
    },
    handlePrint() {
      console.log(this.formData);
    },

    // 音频
    beforeUploadAudio(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp3") {
        this.$message.error("上传音频仅支持mp3格式");
        return false; // 终止上传
      }
    },
    async handleAudioChange(file) {
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp3") {
        this.$message.error("上传视频只能是 MP3格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.audioUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.material.materialUrl =
                this.audioUrl;
            this.formData.lessonContentTemplate.material.filename =
                this.ossUploadObj.filename;
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            // 获取音频时长
            const audio = document.createElement("audio");
            audio.src = URL.createObjectURL(file.raw);
            audio.addEventListener("loadedmetadata", () => {
              if (Math.floor(audio.duration) === 0) {
                this.formData.lessonContentTemplate.material.duration = 1;
                this.formData.lessonContentTemplate.materials[0].duration = 1;
              } else {
                this.formData.lessonContentTemplate.material.duration = Math.floor(audio.duration);
                this.formData.lessonContentTemplate.materials[0].duration = Math.floor(audio.duration);
              }
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("音频上传失败，请重新上传");
            this.audioUrl = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewAudio() {
      this.audioUrl = "";
    },
    // 视频
    beforeUploadVideo(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp4") {
        this.$message.error("上传视频仅支持mp4格式");
        return false; // 终止上传
      }
    },
    async handleVideoChange(file) {
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp4") {
        this.$message.error("上传视频只能是 MP4格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.videoUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.material.filename =
                this.ossUploadObj.filename;
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            // 获取视频时长
            const video = document.createElement("video");
            video.src = URL.createObjectURL(file.raw);
            video.addEventListener("loadedmetadata", () => {
              if (Math.floor(video.duration) === 0) {
                this.formData.lessonContentTemplate.material.duration = 1;
                this.formData.lessonContentTemplate.materials[0].duration = 1;
              } else {
                this.formData.lessonContentTemplate.material.duration = Math.floor(video.duration);
                this.formData.lessonContentTemplate.materials[0].duration = Math.floor(video.duration);
              }
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("视频上传失败，请重新上传");
            this.videoUrl = "";
            console.log(e);
          });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewVideo() {
      this.videoUrl = "";
    },
    //图片
    async handleImgChange(file) {
      this.loading = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.imageUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.material.materialUrl =
                this.imageUrl;
            this.formData.lessonContentTemplate.material.filename =
                this.ossUploadObj.filename;
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.$message.error("图片上传失败，请重新上传");
            this.imageUrl = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    pickMaterial(event) {
      this.materialType = this.formData.contentPattern;
      this.setData({key: "materialPickVisible", value: true});
      event.stopPropagation();
    },
    onOpenPickTextMaterialModal() {
      this.materialType = "text";
      this.setData({key: "materialPickVisible", value: true});
    },
    onConfirmPickMaterial(item) {
      if (this.materialType === "image") {
        this.imageUrl = item.url;
      } else if (this.materialType === "audio") {
        this.audioUrl = item.url;
      } else if (this.materialType === "video") {
        this.videoUrl = item.url;
      }
      this.formData.lessonContentTemplate.material.materialUrl = item.url;
      this.formData.lessonContentTemplate.material.duration = item.duration;
      this.formData.lessonContentTemplate.material.id = item.id;
      this.formData.lessonContentTemplate.material.materialId = item.id;
      this.formData.lessonContentTemplate.materials[0].materialUrl = item.url;
      this.formData.lessonContentTemplate.materials[0].duration = item.duration;
      this.formData.lessonContentTemplate.materials[0].id = item.id;
      this.formData.lessonContentTemplate.materials[0].materialId = item.id;
    },
  },
};
</script>

<style lang="scss" scoped>
//题干转音频
.changeTitleTypeBox {
  margin-left: 90px;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.btn {
  text-align: right;
}

//图片
.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-bottom: 20px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  margin-bottom: 10px;
}
</style>
